import posthog from "posthog-js";

const projectToken = process.env.VUE_APP_POSTHOG_PROJECT_TOKEN;
const host = process.env.VUE_APP_POSTHOG_HOST;
const isDevelopment = process.env.NODE_ENV === "development";

// Avisa, mas não lança: este módulo é importado pelo store, então um throw
// aqui derruba o app antes do Vue montar (tela branca) só porque falta uma
// variável de analytics. Quem clona o repo sem `.env.local` configurado não
// consegue nem subir o dev server. Sem as variáveis o `init` não roda e o SDK
// vira no-op, que é o comportamento já usado em produção.
function avisarSeVariavelAusente(name, value) {
  if (!value && isDevelopment) {
    console.error(
      `${name} variable required by PostHog is missing or un-configured, this causes events to be silently missed. This error stops appearing once ${name} is configured`
    );
  }
}

avisarSeVariavelAusente("VUE_APP_POSTHOG_PROJECT_TOKEN", projectToken);
avisarSeVariavelAusente("VUE_APP_POSTHOG_HOST", host);

export const posthogAtivo = Boolean(projectToken && host);

if (posthogAtivo) {
  posthog.init(projectToken, {
    api_host: host,
    defaults: "2026-05-30",
    // A home fica no ar 24/7 sem ninguém na frente: gravar isso é só banda de
    // 4G e ruído. A gravação é ligada em `sincronizarCompra`, quando uma compra
    // começa, e desligada quando ela termina.
    disable_session_recording: true,
    // Exceções são capturadas por src/service/monitoramentoErros.js, com
    // deduplicação e limite por minuto. Desligado explicitamente para o config
    // remoto do projeto não ligar o autocapture do SDK por cima e duplicar.
    capture_exceptions: false,
  });
  // Super properties ficam persistidas em localStorage: sem isto, o id da
  // última compra do boot anterior continuaria colado em todos os eventos até
  // uma compra nova começar.
  posthog.unregister("compra_id");
}

let totemIdentificado = null;
let compraRegistrada = null;

// O totem é a "pessoa" no PostHog. Identificar pelo uid do Firebase não serve:
// a frota inteira autentica com a mesma conta de serviço, então todos os
// totens virariam uma pessoa só.
export function identificarTotem(totemId, propriedades = {}) {
  if (!posthogAtivo || !totemId) return;

  if (totemIdentificado === totemId) {
    if (Object.keys(propriedades).length) {
      posthog.setPersonProperties(propriedades);
    }
    return;
  }

  // Totem reprovisionado com outro id no mesmo navegador: sem o reset o
  // histórico do totem antigo seria fundido no novo.
  if (totemIdentificado) posthog.reset();

  posthog.identify(totemId, propriedades);
  posthog.register({ totem_id: totemId });
  totemIdentificado = totemId;
  // reset() acima limpa as super properties, inclusive a compra em andamento.
  compraRegistrada = null;
}

// Segundo identificador: o id da compra atual vai como super property, então
// todo evento emitido durante o fluxo carrega `compra_id` sem precisar repetir
// a propriedade em cada capture().
export function sincronizarCompra(compraId) {
  if (!posthogAtivo) return;

  const id = compraId || null;
  if (id === compraRegistrada) return;

  compraRegistrada = id;

  if (id) {
    // Sessão nova por compra: a janela de sessão do PostHog é de 30 min, então
    // sem isto dois clientes seguidos cairiam numa gravação só, com o intervalo
    // ocioso no meio.
    posthog.sessionManager?.resetSessionId();
    posthog.register({ compra_id: id });
    posthog.startSessionRecording();
  } else {
    posthog.unregister("compra_id");
    posthog.stopSessionRecording();
  }
}

export default posthog;
